module.exports = __webpack_public_path__ + "img/Astronaut.2ea55bde.svg";